export enum BlockTypes {
  USER = "user",
  LOAD_BALANCER = "load_balancer",
  APP_SERVER = "app_server",
  DATABASE = "database",
  DB_READ_REPLICA = "db_read_replica",
  CDN = "cdn",
  AUTO_SCALING_GROUP = "auto_scaling_group",
  CACHE = "cache",
  LAMBDA = "lambda",
  QUEUE = "queue",
  NETWORK_LOAD_BALANCER = "network_load_balancer",
  NO_SQL_DB = "no_sql_db",
  GRAPH_DB = "graph_db",
  DOCUMENT_DB = "document_db",
  S3_BUCKET = "s3_bucket",
  PASSTHROUGH = "passthrough",
  ARROW = "arrow",
  TEXT_BOX = "text_box",
}
